import token, { tokenToVars } from '../token';
import Breadcrumb from './breadcrumb';

export { Breadcrumb };
export default tokenToVars(Breadcrumb, token);
